import React from 'react';
import appointmentSelectors from 'features/appointment/services/selectors';
import styled from 'styled-components';
import {
  APPOINTMENT_LAYOUT,
  APPOINTMENT_STATUS,
  CANCEL_CONFIG,
  CHECK_IN_CONFIG,
  CONFIRM_CONFIG,
  NEW_CONFIG,
  NO_SHOW_CONFIG,
} from 'features/appointment/services/constants';
import appointmentActions from 'features/appointment/services/actions';
import { useAppDispatch } from 'store/hooks';

const SummaryByStatus = () => {
  const summaryByStatus = appointmentSelectors.summaryByStatus() || [];
  const dispatch = useAppDispatch();

  const label = {
    NEW: 'NEW',
    CONFIRM: 'CONFIRMED',
    CANCEL: 'CANCELLED',
    NO_SHOW: 'NO SHOW',
    CHECK_IN: 'CHECK IN',
    DELETED: 'DELETED',
  };

  const keyNewValue = {
    NEW: 'NEW',
    CONFIRM: 'CONFIRM',
    CANCEL: 'CANCEL',
    NO_SHOW: 'NO_SHOW',
    CHECK_IN: 'CHECK_IN',
    DELETED: 'DELETE',
    PAID: 'PAID',
  };

  const listStatus = [
    {
      label: label.NEW,
      value: APPOINTMENT_STATUS.NEW,
      fill: NEW_CONFIG.value.fill,
      stroke: NEW_CONFIG.value.stroke,
      newValue: keyNewValue.NEW,
    },
    {
      label: label.CONFIRM,
      value: APPOINTMENT_STATUS.CONFIRM,
      fill: CONFIRM_CONFIG.value.fill,
      stroke: CONFIRM_CONFIG.value.stroke,
      newValue: keyNewValue.CONFIRM,
    },
    {
      label: label.CANCEL,
      value: APPOINTMENT_STATUS.CANCEL,
      fill: CANCEL_CONFIG.value.fill,
      stroke: CANCEL_CONFIG.value.stroke,
      newValue: keyNewValue.CANCEL,
    },
    {
      label: label.NO_SHOW,
      value: APPOINTMENT_STATUS.NO_SHOW,
      fill: NO_SHOW_CONFIG.value.fill,
      stroke: NO_SHOW_CONFIG.value.stroke,
      newValue: keyNewValue.NO_SHOW,
    },
    {
      label: label.CHECK_IN,
      value: APPOINTMENT_STATUS.CHECK_IN,
      fill: CHECK_IN_CONFIG.value.fill,
      stroke: CHECK_IN_CONFIG.value.stroke,
      newValue: keyNewValue.CHECK_IN,
    },
    {
      label: label.DELETED,
      value: APPOINTMENT_STATUS.DELETE,
      fill: CANCEL_CONFIG.value.fill,
      stroke: CANCEL_CONFIG.value.stroke,
      newValue: keyNewValue.DELETED,
    },
  ];

  const handleClickStatus = (status: APPOINTMENT_STATUS) => {
    dispatch(appointmentActions.setTableParams({ status: [String(status)], page: 1 }));
    dispatch(appointmentActions.setAppointmentLayout(APPOINTMENT_LAYOUT.LIST));
  };

  return (
    <Container>
      {listStatus.map((item) => {
        const bgColor = item.fill;
        const total = summaryByStatus.find((o) => o.status === item.newValue)?.total || 0;
        return (
          <div
            className='item'
            key={item.newValue}
            style={{ backgroundColor: bgColor || '#fff' }}
            onClick={() => handleClickStatus(item.value)}
          >
            <div className='value'>{total}</div>
            <div className='status-title'>{item.label}</div>
          </div>
        );
      })}
    </Container>
  );
};

export default SummaryByStatus;

const Container = styled.div`
  display: flex;
  align-items: center;
  .item {
    cursor: pointer;
    display: flex;
    padding: 4px 8px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2px;
    flex: 1 0 0;
    .value {
      color: #1d2129;
      text-align: center;
      font-family: 'Archivo Black';
      font-size: 40px;
      font-style: normal;
      font-weight: 400;
      line-height: 32px; /* 80% */
    }
    .status-title {
      white-space: nowrap;
      color: #505050;
      text-align: center;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
  .item:not(:last-child) {
    border-right: 1px solid #232f3e;
  }
`;
